import { createContext, useContext } from "react";

/** True inside a `DocumentPreview`. Radix portals keep React context, so portaled content reads it too. */
export const ForcedLightContext = createContext(false);

/** Class that carries the light token scope onto content portaled out of a forced-light subtree. */
export function useForcedLightClass(): string | undefined {
  return useContext(ForcedLightContext) ? "force-light" : undefined;
}
